import { Injectable } from '@angular/core';

import { EventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { DeviceService } from '@frontend/vanilla/core';

import { EpcotConfigService } from './epcot-config.service';

@Injectable()
export class EDPScoreboardConfigService {
    constructor(
        private device: DeviceService,
        private epcotConfigService: EpcotConfigService,
        private eventDetailsConfig: EventDetailsConfig,
    ) {}

    isNewEDPScoreboardEnabled(): boolean {
        return (
            this.epcotConfigService.isEnabled() &&
            this.eventDetailsConfig.isNewScoreboardEnabled &&
            this.device.isMobilePhone &&
            !this.device.isTablet
        );
    }
}
